import style from "./style.module.scss";
import { useState } from "react";
import Image from "next/image";
import SharedButton from "@components/severalbrands/sharedButton";
import { motion } from "framer-motion";
import Loader from "@components/shared/loader";
import { PostType } from "@components/severalbrands/gqlQueries";
import axios from "axios";
import {
    AllPostsRes,
    DomainInfo,
} from "@components/severalbrands/utils/services";
import { LIMIT } from "pages/severalbrands/blog";
import { getFormattedDate } from "@components/severalbrands/utils";
import { replacePlaceholders } from "@lib/sharedUtils";
export default function FirstSection({
    blogsArrProp,
    domainInfo,
}: {
    blogsArrProp: PostType[];
    domainInfo: DomainInfo;
}) {
    const [blogsArr, setBlogsArr] = useState<PostType[]>(blogsArrProp);
    const [offset, setOffset] = useState(LIMIT);
    const [blogsArrError, setBlogsArrError] = useState(false);
    const [blogsArrLoading, setBlogsArrLoading] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const showMoreClickHandler = async () => {
        setBlogsArrLoading(true);
        try {
            const res = await axios.post<AllPostsRes>(
                "/api/severalBrandsGetData",
                {
                    offset: offset,
                    domainId: domainInfo.id,
                },
            );

            const newPosts = res.data.data.allPosts;

            if (newPosts) {
                setBlogsArr((prev) => [...prev, ...newPosts]);
                setOffset((prev) => prev + LIMIT);
                setBlogsArrLoading(false);
                if (newPosts.length === 0 || newPosts.length < LIMIT) {
                    setShowButton(false);
                }
            }
        } catch (error) {
            if (error) {
                setBlogsArrLoading(false);
                setBlogsArrError(true);
            }
        }
    };

    return (
        <motion.section
            transition={{ duration: 1.5 }}
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lg:mt-28 mt-14 px-4 lg:px-0"
        >
            <h1 className="font-bold text-[#351C4F] 3xl:text-8xl 3xl:leading-[5.5rem] lg:text-6xl lg:leading-[4.5rem] text-3xl leading-10 text-center">
                Lead Generation Insights
            </h1>
            <div className="3xl:mt-7 mt-5 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1053px] max-w-[910px] mx-auto text-center font-light">
                <p>
                    This is where we, at Several Brands, share practical
                    strategies for performance-driven lead generation. Whether
                    you're in legal, auto, home services, or technology, you'll
                    find vertical-specific tactics, industry trends, and
                    practical tips to help you attract high-intent leads and
                    refine your sales funnel.
                </p>
                <div className="mt-3">
                    For downloadable tools and frameworks, visit our{" "}
                    <a
                        href="https://severalbrands.com/key-considerations"
                        className="text-[#EF4F80] hover:underline"
                    >
                        Resources
                    </a>{" "}
                    page.
                </div>
            </div>

            {blogsArr && blogsArr.length ? (
                <div className=" lg:mt-28 mt-14">
                    <h3 className="font-bold text-[#351C4F] 3xl:text-7xl 3xl:leading-[4.5rem] lg:text-5xl lg:leading-[3.5rem] text-2xl leading-9 text-center">
                        Browse the Latest Articles
                    </h3>
                    <div className="  flex  flex-wrap  justify-evenly ">
                        {blogsArr.map((blog) => (
                            <motion.a
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                key={blog.id}
                                className={style["blogEl"]}
                                href={`${
                                    blog.url.isMain
                                        ? blog.url.url
                                        : blog.url.main.url
                                }`}
                            >
                                <div>
                                    <div
                                        className={`${style["imgContainer"]} relative  h-[230px] 3xl:h-[300px] w-[100%]`}
                                    >
                                        <Image
                                            src={`${
                                                blog.image
                                                    ? blog.image.fullPath
                                                    : "/severalbrands/assets/images/placeHolder.png"
                                            }`}
                                            alt="Image"
                                            layout="fill"
                                            objectFit="cover"
                                        />
                                    </div>
                                    <h2 className="font-bold 3xl:text-3xl 3xl:leading-10 lg:text-xl lg:leading-8 text-center mt-9  px-4">
                                        {replacePlaceholders(blog.title, {
                                            category:
                                                blog?.category?.label ??
                                                blog?.category?.name,
                                        })}
                                    </h2>
                                </div>

                                <p className="3xl:text-xl lg:text-base text-sm text-[#B0B0B0] text-center">
                                    Last Updated On :{" "}
                                    {getFormattedDate(blog.updatedAt)}
                                </p>
                            </motion.a>
                        ))}
                    </div>

                    {showButton && (
                        <div className="w-fit mx-auto lg:mt-20 mt-10 ">
                            {blogsArrLoading ? (
                                <Loader size={30} className="text-[#351C4F]" />
                            ) : (
                                <SharedButton
                                    regularButton
                                    onCLick={showMoreClickHandler}
                                >
                                    Show More
                                </SharedButton>
                            )}
                        </div>
                    )}
                    {blogsArrError && (
                        <p className="w-fit mx-auto text-xs mt-1 text-[#ff4242]">
                            Something went wrong
                        </p>
                    )}
                </div>
            ) : (
                <p className="w-fit mx-auto lg:mt-28 mt-14">No Blogs to show</p>
            )}
        </motion.section>
    );
}
